export const invoices = [
  '0 0 32 32',
  `
<path fill="none" stroke-linejoin="round" stroke-linecap="round" stroke-miterlimit="4" stroke-width="1.8667" stroke="#000" d="M8.308 12.45h15.383"></path>
<path fill="none" stroke-linejoin="round" stroke-linecap="round" stroke-miterlimit="4" stroke-width="1.8667" stroke="#000" d="M8.308 17.183h15.383"></path>
<path fill="none" stroke-linejoin="round" stroke-linecap="round" stroke-miterlimit="4" stroke-width="1.8667" stroke="#000" d="M1.8 27.833v-22.483c0-0.314 0.125-0.615 0.347-0.837s0.523-0.347 0.837-0.347h26.033c0.314 0 0.615 0.125 0.837 0.347s0.347 0.523 0.347 0.837v22.483l-4.733-2.367-4.733 2.367-4.733-2.367-4.733 2.367-4.733-2.367-4.733 2.367z"></path>

`,
]
